import { Slider } from "@mui/material";
import { type FC } from "react";
import { IPopupTranslations } from "./FilterItem";

interface FilterPopupRangeProps {
  popupTranslation: IPopupTranslations;
  setRangeValue: (e: number) => void;
  rangeValue: number;
}

const FilterPopupRange: FC<FilterPopupRangeProps> = ({
  popupTranslation,
  rangeValue,
  setRangeValue,
}) => {
  return (
    <div className="filter_popup">
      <div className="filter_popup_subtitle">{popupTranslation.title}</div>
      <Slider
        className="filter_popup_range"
        value={rangeValue}
        aria-label="Default"
        valueLabelDisplay="auto"
        step={10}
        min={10}
        max={1000}
        onChange={(e: any) => setRangeValue(+e?.target?.value ?? 0)}
      />
      <div className="filter_popup_subtitle filter_popup_subtitle-mobile">
        {rangeValue}
      </div>
    </div>
  );
};
export default FilterPopupRange;
